import { render, staticRenderFns } from "./OrderShipmentListFile.vue?vue&type=template&id=43853330&"
import script from "./OrderShipmentListFile.vue?vue&type=script&lang=js&"
export * from "./OrderShipmentListFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43853330')) {
      api.createRecord('43853330', component.options)
    } else {
      api.reload('43853330', component.options)
    }
    module.hot.accept("./OrderShipmentListFile.vue?vue&type=template&id=43853330&", function () {
      api.rerender('43853330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VPL/MyOrder/OrderDetail/OrderShipmentListFile.vue"
export default component.exports